import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

// Send real-user Core Web Vitals to GA4 so performance regressions show up in analytics.
// CLS is multiplied so it survives GA's integer rounding.
const sendToAnalytics = ({ name, delta, id }) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true,
  });
};

const reportWebVitals = () => {
  getCLS(sendToAnalytics);
  getFID(sendToAnalytics);
  getFCP(sendToAnalytics);
  getLCP(sendToAnalytics);
  getTTFB(sendToAnalytics);
};

export default reportWebVitals;
